import { PaymentCardImageTypes } from '@mews/framework/payments';

export const getSourceImageByType = (type: keyof PaymentCardImageTypes) => `${type}.svg`;
